import { createFileRoute, redirect } from "@tanstack/react-router";

function normalizeLegacyAppPath( splat: string | undefined ): string {
    const trimmed = ( splat ?? "" ).trim().replace( /^\/+/, "" );
    if ( !trimmed ) return "/dashboard";

    const normalized = `/${ trimmed }`;

    if ( normalized === "/settings" ) return "/settings/general";
    if ( normalized.startsWith( "/settings/" ) ) return normalized;
    if ( normalized === "/dashboard" ) return "/dashboard";
    if ( normalized === "/issues" ) return "/issues";
    if ( normalized === "/security" ) return "/security";
    if ( normalized === "/notifications" ) return "/notifications";
    if ( normalized === "/clients" ) return "/clients";
    if ( normalized === "/messages" ) return "/messages";
    if ( normalized === "/requests" ) return "/requests";
    if ( normalized === "/signatures" ) return "/signatures";
    return "/dashboard";
}

export const Route = createFileRoute( "/app/$" )( {
    beforeLoad: ( { params, location } ) => {
        const canonicalPath = normalizeLegacyAppPath( params._splat );
        const canonicalHref = `${ canonicalPath }${ location.search }${ location.hash }`;

        throw redirect( {
            href: canonicalHref,
            replace: true,
        } );
    },
} );
